import { useSelector } from 'react-redux';

export default function useCanonical(path) {
	return useSelector((state) => `${state.app.baseUrl}${path}`);
}
